<template>
  <div class="operation-bd tb" style="padding: 0">
    <custom-tab v-model="formSearch.operationsState" :list="tabList"></custom-tab>
    <operations v-if="formSearch.operationsState === 1"></operations>
    <schedules v-else></schedules>
  </div>
</template>

<script>
// import apis from '@/utils/apis';
import operations from './children/operations.vue';
import schedules from './children/schedules.vue';

export default {
  name: 'operation',
  mixins: [],
  components: { operations, schedules },
  data() {
    return {
      provide: true,
      tableSelect: [],

      formSearch: {
        protocolCode: '',
        search: '',
        operationsState: null,
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,
        productCode: '',
        imsi: '',
        tcpVersion: '',
        batteryCharge: [],
        dataTimes: [],
        websiteName: '',
      },
      tableList: [],
      totalRows: 0,
      dialogVisible: false,
      dialogModel: {},
      dialogVisible2: false,
      dialogModel2: {},
      tabList: [],
    };
  },
  activated: function () {
    // this.getTableList();
  },
  mounted: function () {
    this.getFuncView(null, () => {
      const tab = [];
      if (this.funcView.operations_list) {
        tab.push({ name: this.$t('base_operation.bao_gao_ji_lu'), value: 1 });
      }
      if (this.funcView.schedules_list) {
        tab.push({ name: this.$t('base_operation.tui_song_ji_hua'), value: 2 });
      }
      this.tabList = tab;
      if (tab.length > 0) {
        this.formSearch.operationsState = tab[0].value;
      }
    });
  },
  methods: {},
};
</script>

<style lang="scss">
.operation-bd {
  .stock-wrap {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 16px;
    overflow: hidden;
  }
}
</style>
